/**
 * @generated SignedSource<<00bf0f61b8a6525a9e7c6fd264f11f6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleBeforeYouGoTopicsContent$data = {
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "topicLinkTopic">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleBeforeYouGoTopicsContent";
};
export type articleBeforeYouGoTopicsContent$key = {
  readonly " $data"?: articleBeforeYouGoTopicsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleBeforeYouGoTopicsContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleBeforeYouGoTopicsContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicLinkTopic"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityFollowButtonBase"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "01a411a6a94dc78b6dde2828b0fdeb91";

export default node;
